import api from './api';

export const getAppointments = async (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  });
  const response = await api.get(`/appointments?${query.toString()}`);
  return response.data;
};

export const getAppointmentById = async (id) => {
  const response = await api.get(`/appointments/${id}`);
  return response.data;
};

export const createAppointment = async (data) => {
  const response = await api.post('/appointments', data);
  return response.data;
};

export const updateAppointment = async (id, data) => {
  const response = await api.patch(`/appointments/${id}`, data);
  return response.data;
};

export const confirmAppointment = async (id, notes = {}) => {
  const response = await api.post(`/appointments/${id}/confirm`, notes);
  return response.data;
};

export const cancelAppointment = async (id, { cancellationReason }) => {
  const response = await api.post(`/appointments/${id}/cancel`, { cancellationReason });
  return response.data;
};

export const completeAppointment = async (id) => {
  const response = await api.post(`/appointments/${id}/complete`);
  return response.data;
};

export const markAppointmentLost = async (id, { failureReason, notes }) => {
  const response = await api.post(`/appointments/${id}/lost`, { failureReason, notes });
  return response.data;
};

export const mdOverrideAppointment = async (id, payload) => {
  const response = await api.post(`/appointments/${id}/md-override`, payload);
  return response.data;
};

export const getAppointmentHistory = async (id) => {
  const response = await api.get(`/appointments/${id}/history`);
  return response.data;
};

export const createPaymentLink = async (id, payload = {}) => {
  const response = await api.post(`/appointments/${id}/payment-link`, payload);
  return response.data;
};

export const recordOfflinePayment = async (id, payload = {}) => {
  const response = await api.post(`/appointments/${id}/offline-payment`, payload);
  return response.data;
};

export const deleteAppointment = async (id) => {
  const response = await api.delete(`/appointments/${id}`);
  return response.data;
};

export const getAppointmentPayouts = async (appointmentId) => {
  const response = await api.get(`/appointment-payouts/appointment/${appointmentId}`);
  return response.data;
};

export const createAppointmentPayout = async (appointmentId) => {
  const response = await api.post(`/appointment-payouts/appointment/${appointmentId}`);
  return response.data;
};

export const createManualAppointmentPayout = async (appointmentId, payload) => {
  const response = await api.post(`/appointment-payouts/appointment/${appointmentId}/manual`, payload);
  return response.data;
};

export const completeAppointmentPayout = async (payoutId, payload = {}) => {
  const response = await api.post(`/appointment-payouts/${payoutId}/complete`, payload);
  return response.data;
};

export const sendAppointmentPayoutEmail = async (payoutId) => {
  const response = await api.post(`/appointment-payouts/${payoutId}/send-email`);
  return response.data;
};

export const getAppointmentPayoutStatistics = async () => {
  const response = await api.get('/appointment-payouts/statistics');
  return response.data;
};

// 🩺 Appointment Follow-ups Queue APIs
export const getAppointmentFollowUps = async (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  });
  const response = await api.get(`/appointments/follow-ups?${query.toString()}`);
  return response.data;
};

export const getAppointmentFollowUpStatistics = async () => {
  const response = await api.get('/appointments/follow-ups/statistics');
  return response.data;
};

export const updateAppointmentFollowUpStatus = async (prescriptionId, data = {}) => {
  const response = await api.patch(`/appointments/follow-ups/${prescriptionId}/status`, data);
  return response.data;
};
